// import { KYCUploadResponseDTO } from "../../models/claimDetails.models";
import { KYCUploadResponseDTO } from "../../modules/claim/models/claimDetails.models";

export const kycDetailsRed = (initialState = new KYCUploadResponseDTO(), action) => {
    switch(action.type)
    {
        case "kycDetails":
            return action.payload;
        default:
            return initialState
    }
}


export const selfieDetailsRed = (initialState = {}, action) => {
    switch(action.type)
    {
        case "selfieDetails":
            return action.payload;
        default:
            return initialState
    }
}

export const panDetailsRed = (initialState = {}, action) => {
    switch(action.type)
    {
        case "panDetails":
            return action.payload;
        default:
            return initialState
    }
}

export const chequeDetailsRed = (initialState = {}, action) => {
    switch(action.type)
    {
        case "chequeDetails":
            return action.payload;
        default:
            return initialState
    }
}
export const kycUploadDetailsRed=( initialState={}, action)=>{
    switch(action.type)
    {
        case "kycUploadDetails":
            return action.payload;
        default:
            return initialState
    }

}